export const getParsedUrl = (url: string) => {
  const parsedUrl = new URL(url);
  return parsedUrl;
};
